class Z1HHeaderDrawer {

    constructor() {

        this.drawer = document.querySelector('[data-z1h-header-drawer]');

        if (!this.drawer) return;

        this.toggle = document.querySelector('[data-z1h-menu-toggle]');
        this.overlay = this.drawer.querySelector('[data-z1h-overlay]');
        this.closeBtn = this.drawer.querySelector('[data-z1h-close]');

        this.tabs = [...this.drawer.querySelectorAll('[data-tab]')];
        this.panels = [...this.drawer.querySelectorAll('[data-panel]')];

        this.bindEvents();

        this.activateTab(0);

    }

    bindEvents() {

        this.toggle?.addEventListener('click', () => {

            this.open();

        });

        this.closeBtn?.addEventListener('click', () => {

            this.close();

        });

        this.overlay?.addEventListener('click', () => {

            this.close();

        });

        document.addEventListener('keydown', (event) => {

            if (event.key === 'Escape') {

                this.close();

            }

        });

        this.tabs.forEach((tab) => {

            tab.addEventListener('click', () => {

                this.activateTab(
                    Number(tab.dataset.tab)
                );

            });

        });

        class Z1HHeaderDrawer {

    constructor() {

        this.drawer = document.querySelector('[data-z1h-header-drawer]');

        if (!this.drawer) return;

        this.toggle = document.querySelector('[data-z1h-menu-toggle]');
        this.overlay = this.drawer.querySelector('[data-z1h-overlay]');
        this.closeBtn = this.drawer.querySelector('[data-z1h-close]');

        this.tabs = [...this.drawer.querySelectorAll('[data-tab]')];
        this.panels = [...this.drawer.querySelectorAll('[data-panel]')];

        this.bindEvents();

        this.activateTab(0);

    }

    bindEvents() {

        this.toggle?.addEventListener('click', () => {

            this.open();

        });

        this.closeBtn?.addEventListener('click', () => {

            this.close();

        });

        this.overlay?.addEventListener('click', () => {

            this.close();

        });

        document.addEventListener('keydown', (event) => {

            if (event.key === 'Escape') {

                this.close();

            }

        });

    }

    open() {

        this.drawer.classList.add('active');

        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        this.toggle?.setAttribute(
            'aria-expanded',
            'true'
        );

    }

    close() {

        this.drawer.classList.remove('active');

        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';

        this.toggle?.setAttribute(
            'aria-expanded',
            'false'
        );

    }

}

document.addEventListener('DOMContentLoaded', () => {

    new Z1HHeaderDrawer();

});

    }

    activateTab(index) {

        this.tabs.forEach((tab, i) => {

            const active = i === index;

            tab.classList.toggle('active', active);

            tab.setAttribute(
                'aria-selected',
                active
            );

        });

        this.panels.forEach((panel, i) => {

            panel.classList.toggle(
                'active',
                i === index
            );

        });

    }

    open() {

        this.drawer.classList.add('active');

        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        this.toggle?.setAttribute(
            'aria-expanded',
            'true'
        );

    }

    close() {

        this.drawer.classList.remove('active');

        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';

        this.toggle?.setAttribute(
            'aria-expanded',
            'false'
        );

    }

}

document.addEventListener('DOMContentLoaded', () => {

    new Z1HHeaderDrawer();

});